import { render, staticRenderFns } from "./editor-wrapper.vue?vue&type=template&id=6683acac&scoped=true&"
import script from "./editor-wrapper.vue?vue&type=script&lang=js&"
export * from "./editor-wrapper.vue?vue&type=script&lang=js&"
import style0 from "./editor-wrapper.vue?vue&type=style&index=0&id=6683acac&prod&lang=scss&"
import style1 from "./editor-wrapper.vue?vue&type=style&index=1&id=6683acac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6683acac",
  null
  
)

export default component.exports